import { Download } from 'lucide-react';
import BaseButton from '../base-button';

type Props = {
  size?: number;
  iconSize?: number;
  className?: string;
  onClick?: () => void;
};

const DownloadButton = ({ onClick, className, size = 32, iconSize = 16 }: Props) => {
  return (
    <BaseButton onClick={onClick} className={className} size={size}>
      <Download size={iconSize} className="text-white" />
    </BaseButton>
  );
};

export default DownloadButton;
